import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from "react";
import './styles/SubirContenido.css';
import { useForm, useFieldArray } from 'react-hook-form';
import Swal from 'sweetalert2';


const FormularioSesiones = ({editando, datosIniciales, onClose, onSuccess}) => {
    const totalSesionesClase = Array.isArray(datosIniciales?.clase?.Id_Sesion) ? datosIniciales.clase.Id_Sesion.length : 0;
    const cuentaExistente = editando ? 0 : totalSesionesClase;

    //Fecha de inicio y de fin de la clase a la que pertenece las sesiones, para validar la fecha
    const inicioClase = datosIniciales?.clase?.FechaInicio ? new Date(datosIniciales.clase.FechaInicio) : null;
    const finClase = datosIniciales?.clase?.FechaFin ? new Date(datosIniciales.clase.FechaFin) : null;
    
    //Valores por defecto
    const { register, handleSubmit, control, watch, setValue, reset, formState: { errors } } = useForm({
    defaultValues: {
        numSesiones: 1,
        sesiones: [{ Parte: cuentaExistente + 1, Nombre: '', URL: '', Fecha: '', Duracion: '' }],
        claseId: datosIniciales?.clase?._id || '',
    },
});

const { fields: sesiones, replace } = useFieldArray({
    control,
    name: 'sesiones',
});

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

//Modo edición => Cuando llegue initialData establecemos valores de los campos
useEffect(() => {
    if(editando && datosIniciales){
        const sesionAEditar = {
            Parte: datosIniciales.Sesion.Parte,         
            Nombre: datosIniciales.Sesion.Nombre,
            URL: datosIniciales.Sesion.Enlace,
            Fecha: new Date(datosIniciales.Sesion.Fecha).toISOString().slice(0, 16),
            Duracion: datosIniciales.Sesion.Duracion
        };

        reset({
            numSesiones: 1, // En modo edición no importa cuántas sesiones se inserten
            sesiones: [{
                Parte: datosIniciales.Sesion.Parte,
                Nombre: datosIniciales.Sesion.Nombre,
                URL: datosIniciales.Sesion.Enlace,
                Fecha: new Date(datosIniciales.Sesion.Fecha).toISOString().slice(0, 16),
                Duracion: datosIniciales.Sesion.Duracion,
            }], 
            claseId: datosIniciales.clase?._id || '',
        });
    }
}, [editando, datosIniciales, reset]);

//Establecer número de sesiones a insertar
const numSesiones = watch('numSesiones');

//Establecer número de sesiones
useEffect(() => {
    if(!editando){
        const count = parseInt(numSesiones, 10) || 1;
        const nuevos = Array.from({ length: count }, (_, i) => ({
            Parte: cuentaExistente + i + 1,
            Nombre: '',
            URL: '',
            Fecha: '',
            Duracion: '',
        }));
        replace(nuevos);
    }
}, [numSesiones, replace, editando, cuentaExistente]);


const onSubmit = async data => {
    let fetchUrl;
    let metodo;
    const claseId = data.claseId;
    metodo = 'PUT';

    const claseSesionesIds = datosIniciales.clase.Id_Sesion.map(id => id.toString());
    const claseSesionesParam = claseSesionesIds.join(',');

    let bodyJSON;
    
    if(!editando){
        const sesionesPayload = data.sesiones.map(s => ({
            Parte: s.Parte,
            Nombre: s.Nombre,
            Enlace: s.URL,
            Fecha: s.Fecha,
            Duracion: s.Duracion
        }));

        bodyJSON = {sesiones: sesionesPayload}

        fetchUrl = `${baseUrl}/api/clases/sesion/${claseId}/sesiones`;
    } else {
        const sesion = data.sesiones[0];
        bodyJSON = {
            Parte: sesion.Parte,
            Nombre: sesion.Nombre,
            Enlace: sesion.URL,
            Fecha: sesion.Fecha,
            Duracion: sesion.Duracion
        };
        const sesionId = datosIniciales.Sesion._id; 
        fetchUrl = `${baseUrl}/api/sesiones/${sesionId}/${claseSesionesParam}`;
    }

    try{
        const resp = await fetch(fetchUrl, {
            method: metodo,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(bodyJSON)
        });

        if (!resp.ok) {
            throw new Error(`HTTP ${resp.status}`);
        }

        const result = await resp.json();
        
        if(!editando){
            console.log('Sesiones creadas y añadidas a la clase:', result);
            await Swal.fire({
                icon: 'success',
                title: '¡Éxito!',
                text: 'Sesiones creadas y asignadas a la clase correctamente.',
                confirmButtonText: 'OK'
            });
            if(onSuccess) onSuccess(result);
            if(onClose) onClose();
        }
        else{
            console.log('Edición de sesión OK', result);
            await Swal.fire({
                icon: 'success',
                title: '¡Sesión modificada!',
                text: 'Sesión modificada de forma exitosa.',
                confirmButtonText: 'OK'
            });
            if(onSuccess) onSuccess(result);
            if(onClose) onClose();
        }       
    } catch(error){
        console.error(editando ? 'Error al modificar la sesión' : 'Error al insertar sesiones:', error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: editando 
                ? 'Ha ocurrido un error al modificar la sesión.' 
                : 'Ha ocurrido un error al crear las sesiones.',
            confirmButtonText: 'Aceptar'
        });
    }
};

const today = new Date().toISOString().split('T')[0];
const ahoraISO = new Date().toISOString();
const minFechaHora = ahoraISO.slice(0, 16);
const originalSessionDate = editando
  ? new Date(datosIniciales.Sesion.Fecha).toISOString().slice(0,16)
  : null;

    return (
        <div className='principalCont'>
            <div className='wrapperCont'>
                <form onSubmit={handleSubmit(onSubmit)}>               
                    {!editando && (
                        <div className='campo-enlinea'>
                            <label>Número de sesiones:</label>
                            <input type="number" min="1" {...register('numSesiones', { required: true, valueAsNumber: true, validate: v => Number.isInteger(v) || 'Debe ser un entero' })} />
                            {errors.numSesiones && <span className='error'>Requerido</span>}
                            
                            <input type="hidden" {...register('claseId', { required: true })} />
                        </div>
                    )}

                    {sesiones.map((field, index) => (
                        <div key={index}>
                            {!editando ? (<h4>Sesión {index + 1}</h4>) : <h4>Modificando sesión {datosIniciales.Nombre}</h4>}
                            <br/>

                            <div className='campo-enlinea'>
                                <label>Parte:</label>
                                {editando ? 
                                (
                                <>
                                    <input type="number" min="1" max={totalSesionesClase} {...register(`sesiones.${index}.Parte`, {required: true, valueAsNumber: true, validate: (v) => {
                                        if (!Number.isInteger(v)) return 'Debe ser un entero'; 
                                        if(v < 1) return 'Parte mínima es 1'; 
                                        if(v > totalSesionesClase) return `Parte máxima es ${totalSesionesClase}`;
                                        return true;
                                    },
                                    })} 
                                    />
                                    {errors.sesiones?.[index]?.Parte && (
                                        <span className='error'>
                                            {errors.sesiones?.[index]?.Parte &&  <span className='error'>Requerido</span>}
                                        </span>
                                    )}
                                </>
                                ) : (<input type="number" value={cuentaExistente + index + 1} readOnly {...register(`sesiones.${index}.Parte`)}/>)}
                            
                            </div>
                            <div>
                                <label>Nombre de la sesión:</label>
                                <input type="text" {...register(`sesiones.${index}.Nombre`, { required: true })} />
                                {errors.sesiones?.[index]?.Nombre && <span className='error'>Requerido</span>}
                            </div>
                            <div>
                                <label>URL:</label>
                                <input type="url" {...register(`sesiones.${index}.URL`, { required: true, validate: value => {
                                    // Patrón para URLs de Google Meet: https://meet.google.com/xxx-xxxx-xxx
                                    const meetRe = /^https:\/\/meet\.google\.com\/[a-z0-9]{3}-[a-z0-9]{4}-[a-z0-9]{3}$/i;

                                    // Patrón para URLs de Zoom: https://us02web.zoom.us/j/1234567890 o cualquier subdominio
                                    const zoomRe = /^https:\/\/(?:[a-z0-9-]+\.)?zoom\.us\/j\/\d+(?:\?[\w=&-]+)?$/;
                                    if (meetRe.test(value) || zoomRe.test(value)) {
                                        return true;
                                    }
                                    return 'Debido a politicas de la web solo se permiten URL de google meet o zoom';
                                } })} />
                                {errors.sesiones?.[index]?.URL && <span className='error'>Error, indique un enlace de Meet o Zoom</span>}
                            </div>
                            <div>
                                <label>Fecha de la sesión: </label>
                                <input type="datetime-local" min={editando ? undefined : minFechaHora} {...register(`sesiones.${index}.Fecha`, {required: true, validate: v => { 
                                    if (editando && v === originalSessionDate) {
                                        return true;
                                    }

                                    const fechaS = new Date(v);
                                    
                                    if (fechaS < new Date(today)) {
                                        return 'No puede ser anterior a la fecha actual';
                                    }
                                    if (fechaS < inicioClase) {
                                        return 'No puede ser anterior a Fecha de inicio de clase';
                                    }
                                    if (fechaS > finClase) {
                                        return 'No puede ser posterior a Fecha de fin de clase';
                                    }
                                    return true;
                                }})} />
                                {errors.sesiones?.[index]?.Fecha && <span className='error'>Requerido</span>}
                            </div>
                            <div className='campo-enlinea'>
                                <label htmlFor="duracionSesion">Duración de la sesión: </label>
                                <input id="duracionSesion" type="number" min="0" {...register(`sesiones.${index}.Duracion`, {required: true, valueAsNumber: true, validate: v => Number.isInteger(v) || 'Debe ser un entero'})} /> minutos
                                {errors.sesiones?.[index]?.Duracion && <span className='error'>Requerido</span>}
                            </div>
                        </div>
                    ))}
                    <button className='botonSubmit' type="submit">{editando ? 'Guardar cambios' : 'Subir sesiones'}</button>
                </form>
            </div>
        </div>
    );
};



export default FormularioSesiones;